import { SportingSecureParams } from 'services/sporting/types';
import { getSportingChatURL } from 'services/sporting/utils/getSportingURL';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  idDraft: number;
  newOrderNumber: number;
};

export const changeDraftOrderNumber = async (
  params: SportingSecureParams<Payload>
) => {
  const { payload } = params;

  const endpointURL = getSportingChatURL('changeDraftOrderNumber');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
